// src/Components/BankingReconciliation/components/ReconHeader/ReconHeader.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../../assets/images/backIcon.svg";
import Styles from "./ReconHeader.module.css";

const ReconHeader = ({ dateRange, subtitle, onExport, isExporting }) => {
  const navigate = useNavigate();

  return (
    <header className={Styles.header}>
      <div className={Styles.topBar}>
        <div className={Styles.backBtn} onClick={() => navigate(-1)}>
          <BackIcon />
          Back
        </div>
        <div className={Styles.barHeading}>Banking Energy Reconciliation</div>
      </div>
      <nav className={Styles.breadcrumb}>
        {/* <span>Reconciliation</span> */}
        {/* <span className={Styles.sep}>›</span> */}
        {/* <span className={Styles.current}>Requisition-wise</span> */}
      </nav>
      <div className={Styles.titleRow}>
        <div className={Styles.breadcrumb}>
          {/* <h1 className={Styles.title}>Banking Energy Reconciliation</h1> */}
          {/* <div className={Styles.metaRow}>
            <span className={Styles.dateChip}>📅 {dateRange}</span>
            <span className={Styles.subtitle}>{subtitle}</span>
          </div> */}
          <span className={Styles.sectionTitle}>Reconciliation</span>
        </div>
        <button
          type="button"
          className={Styles.exportBtn}
          onClick={onExport}
          disabled={isExporting}
        >
          ⬇ {isExporting ? "Generating…" : "Download report"}
        </button>
      </div>
    </header>
  );
};

export default ReconHeader;
